const STATUS_ORDER = ['sent', 'delivered', 'read', 'failed'];

function normalizeIncomingStatus(status) {
  if (!status) return null;
  if (typeof status === 'string') return status.toLowerCase();
  if (typeof status === 'object') return (status.type || status.status || '').toLowerCase();
  return `${status}`.toLowerCase();
}

function shouldUpgradeStatus(currentStatus, incomingStatus) {
  if (incomingStatus === 'failed') return true;
  const currentRank = STATUS_ORDER.indexOf(normalizeIncomingStatus(currentStatus) || 'sent');
  const incomingRank = STATUS_ORDER.indexOf(incomingStatus);
  if (incomingRank === -1) return false;
  if (currentRank === -1) return true;
  return incomingRank > currentRank;
}

export function createHandleMessageStatus({ setMessageList }) {
  return (payload) => {
    if (!payload?.w_id) return;

    setMessageList((prev) => {
      if (!prev?.messages?.length) return prev;

      const incomingStatus = normalizeIncomingStatus(payload.status);
      const hasMatch = prev.messages.some(
        (message) => message.w_id === payload.w_id || message.msg_id === payload.w_id
      );
      if (!hasMatch) return prev;

      return {
        ...prev,
        messages: prev.messages.map((message) => {
          const isMatch = message.w_id === payload.w_id || message.msg_id === payload.w_id;
          if (!isMatch) return message;

          const currentStatus = message?.status?.type || message?.status;
          if (!shouldUpgradeStatus(currentStatus, incomingStatus)) return message;

          return {
            ...message,
            w_id: message.w_id || payload.w_id,
            status: {
              type: incomingStatus || currentStatus,
              timestamp: payload.timestamp || message?.status?.timestamp,
            },
          };
        }),
      };
    });
  };
}
